import { render, staticRenderFns } from "./RiskBirimleri.vue?vue&type=template&id=4fff2567"
import script from "./RiskBirimleri.vue?vue&type=script&lang=js"
export * from "./RiskBirimleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports